<template>
    <div>
       <chatOrdersMessage v-if="!msg.ReportType" :msg="msg" :vers="vers"/>
       <chatReportMessage :extendStatus="extendStatus" v-if="msg.ReportType" :msg="msg"/>
    </div>
</template>
<script>
import chatOrdersMessage from './chat-robot-orders';
import chatReportMessage from './chat-robot-reports';
export default {
    components: {
        chatOrdersMessage,
        chatReportMessage
    },
    props:['msg','vers','extendStatus']
}
</script>
<style lang="less" scoped>
.robotMessage {
    &-title {
        line-height: 1.54;
    }
    &-dataWrap {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 8px;
        &:last-child {
            margin-bottom: 0px;
        }
    }
    &-dataItem {
        margin-right: 23px;
        min-width: 100px;
    }
    &-dataItem {
        &_title {
            font-size:10px;
            color:#adc7e1;
            line-height: 2;
        }
    }
}
</style>

